module.exports = __webpack_public_path__ + "takip2.jpg?849aaa1ee73067b18bedf809ddfc6588";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/takip2.jpg
// module id = 316
// module chunks = 0